import { createContext, useContext, useState, useEffect } from 'react'
import { authAPI } from '../services/api'

const AuthContext = createContext()

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider')
  }
  return context
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        const result = await authAPI.verify()
        if (result) {
          setUser({
            userId: result.data.userId,
            username: result.data.username,
            role: result.data.role,
            name: result.data.name,
            salespersonId: result.data.salespersonId || null,
          })
        }
      } catch (error) {
        // 토큰 없거나 만료 → 미인증 상태
      } finally {
        setLoading(false)
      }
    }
    verifyAuth()

    // apiFetch 401 에러 시 React 상태 기반 로그아웃
    const handleForceLogout = () => setUser(null)
    window.addEventListener('auth:logout', handleForceLogout)
    return () => window.removeEventListener('auth:logout', handleForceLogout)
  }, [])

  const login = async (username, password) => {
    try {
      const result = await authAPI.login(username, password)
      if (result.success) {
        setUser({
          userId: result.data.userId,
          username: result.data.username,
          role: result.data.role,
          name: result.data.name,
          salespersonId: result.data.salespersonId || null,
        })
        return { success: true }
      }
      return { success: false, message: result.message }
    } catch (error) {
      return { success: false, message: '서버 연결에 실패했습니다.' }
    }
  }

  const logout = async () => {
    await authAPI.logout()
    setUser(null)
  }

  return (
      <AuthContext.Provider value={{ user, login, logout, loading }}>
        {children}
      </AuthContext.Provider>
  )
}
